<template>
  <div
    :class="[
      relativeToParent ? 'absolute inset-0' : 'fixed inset-0 overflow-y-auto',
      'z-50',
      { 'pt-[56px]': full }
    ]"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex h-full items-center justify-center px-[8px] pb-[40px] pt-[76px] text-center sm:items-center sm:px-0 sm:pt-0"
    >
      <div
        :class="[relativeToParent ? 'absolute inset-0' : 'fixed inset-0', 'bg-gpx_black-500 opacity-[48%]']"
        @click.prevent="!persistent && $emit('close')"
        aria-hidden="true"
      ></div>
      <div
        class="relative inline-block pb-0 text-left transition-all"
        :class="[
          large ? 'w-full sm:w-[560px]' : 'w-full sm:w-[400px]',
          { 'md:w-[908px]': full },
        ]"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    full: {
      type: Boolean,
      required: false,
      default: false,
    },
    relativeToParent: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** Blocks backdrop dismissal, for a step whose content cannot be shown again. */
    persistent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
